import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAllProfessionals, getProfessionalById } from "../../service/MainService";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import noimg from "../../assets/images/noimg.webp";

const PatrocinosCards = () => {
  const [professionals, setProfessionals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const professionalsData = await getAllProfessionals(0, 10);
        setProfessionals(professionalsData.Result);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleSponsorClick = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const userDetails = await getProfessionalById(userId, token);
      navigate(`/professionals/${userId}`, {
        state: { userDetails },
      });
    } catch (error) {
      console.error("Error navigating to professional:", error);
    }
  };

  return (
    <div className="">
      <section className="text-gray-600 mb-10 body-font">
        <div className="flex flex-col text-center w-full mt-5 mb-5">
          <h1 className="text-sm title-font font-semibold text-gray-500">
            SPONSORED
          </h1>
        </div>
        <Swiper
          slidesPerView={5}
          spaceBetween={20}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
        >
          {professionals.map((spo, index) => (
            <SwiperSlide key={index} className="mb-10">
              <div
                className="flex flex-col items-center h-68 justify-center border border-gray-300 p-4 cursor-pointer hover:shadow-lg hover:border-blue-400 transition-all duration-200"
                onClick={() => handleSponsorClick(spo.UserId)}
              >
                <img
                  src={spo.ProfilePicture || noimg}
                  alt={spo.Name || "Professional"}
                  className="rounded-full shadow-lg w-34 h-34 border-2 border-gray-900 object-cover"
                  style={{ width: "150px", height: "150px" }}
                />
                <h2 className="text-md font-semibold text-center mt-5 text-gray-900">
                  {spo.Name}
                </h2>
                <p className="text-sm text-center">
                  {spo.ProfessionPositionName}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
};

export default PatrocinosCards;
